// removed by extract-text-webpack-plugin
module.exports = {"breadcrumbs":"Breadcrumbs-m__breadcrumbs___UG0Dr","breadcrumbs_item":"Breadcrumbs-m__breadcrumbs_item___2mrxH","breadcrumbsItem":"Breadcrumbs-m__breadcrumbs_item___2mrxH","breadcrumbs_link":"Breadcrumbs-m__breadcrumbs_link___1Z0ek","breadcrumbsLink":"Breadcrumbs-m__breadcrumbs_link___1Z0ek"};


//////////////////
// WEBPACK FOOTER
// ./components/breadcrumbs/Breadcrumbs.m.sass
// module id = DzZD
// module chunks = 0